import { mapActions } from 'vuex';
import router from '@/router';
import {
  HTTP_CAMPAIGNS, HTTP_CONF,
  HTTP_DESKRH,
  HTTP_DOCUMENTS,
  HTTP_ORGANIZATIONS,
  HTTP_USERS,
  updateAuthorization,
  clearSessionInformation,
} from './http';

export default {
  methods: {
    ...mapActions({
      openSnackbar: 'application/openSnackbar',
    }),
    setInterceptors() {
      // request went well
      const responseHandler = (response) => {
        updateAuthorization(response);
        return response;
      };
      // error returned
      const errorHandler = (error) => {
        if (error.response.status === 401) {
          router.push({ name: 'Login', params: { expired: true } });
          clearSessionInformation();
          this.openSnackbar({
            message: this.$i18n.t('login.warning.session-expired'),
          });
        }
        updateAuthorization(error);
        return Promise.reject(error);
      };
      HTTP_ORGANIZATIONS.interceptors.response.use(responseHandler, errorHandler);
      HTTP_CAMPAIGNS.interceptors.response.use(responseHandler, errorHandler);
      HTTP_DESKRH.interceptors.response.use(responseHandler, errorHandler);
      HTTP_USERS.interceptors.response.use(responseHandler, errorHandler);
      HTTP_DOCUMENTS.interceptors.response.use(responseHandler, errorHandler);
      HTTP_CONF.interceptors.response.use(responseHandler, errorHandler);
    },
  },
};



// WEBPACK FOOTER //
// ./src/interceptors.js